/**
 * Created by USER on 18/5/29.
 */
/**
 * Created by USER on 18/5/28.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import {changeBarState} from '../redux/actions/headerbar_action';
import ImageList from  '../images/img';


class PaymentComplete extends Component {
  componentWillMount() {
    this.props.dispatch(changeBarState('product'));
  }

  render() {
    const { t } = this.props;
    return (
      <div className="payment_page payment_complete_page">
        <div className="order_success_system">
          <div className="order_success_system_icon">
            <i className="icon iconfont icon-ordersus" />
          </div>
          <div className="order_success_system_title">
            {t('payment_complete')}
          </div>
          <div className="order_success_system_note">
            {t('payment_complete_note')}
          </div>
          <div className="order_success_system_note prize_note">
            {t('payment_complete_prize_note')}
          </div>
          <div className="order_success_system_note">
            <img src={ImageList.img.publicQrcode} alt="LUBANSO" />
          </div>
        </div>
      </div>
    );
  }
}

// {/*<div className="down_invoice">*/}
// {/*<Button className="down_invoice_button">下载发票</Button>*/}
// {/*</div>*/}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const PaymentCompleteTranslate = translate('translations')(PaymentComplete);

export default connect(select)(PaymentCompleteTranslate);

